import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-loader-train",
  templateUrl: "./loader-train.component.html",
  styleUrls: ["./loader-train.component.scss"],
})
export class LoaderTrainComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
